import * as React from "react";
import { ChapterListProps, ChapterListState } from "./chapter.types";
import { isStringArray } from "./chapter.helpers";
import { Icon } from "../Icon/icon";

export class ChapterList extends React.Component<
  ChapterListProps,
  ChapterListState
> {
  constructor(props: ChapterListProps) {
    super(props);
    this.state = {
      IsOpen: false,
    };
  }

  toggleExpanded = () => {
    this.setState({
      IsOpen: !this.state.IsOpen,
    });
  };

  render() {
    const { hideIcon, heading, chapters } = this.props;
    const { IsOpen } = this.state;

    return (
      <div className={`chapter-list ${IsOpen ? "chapter-list--expanded" : ""}`}>
        <button
          className="chapter-list__head"
          aria-label="Öppna eller stäng kapitelmenyn"
          onClick={this.toggleExpanded}
        >
          <span
            className={`chapter-list__chevron chevron ${
              IsOpen ? "chevron--bottom" : ""
            }`}
          />
          <span className="chapter-list__icon-container">
            {!hideIcon && (
              <Icon className="chapter-list__chapter-icon" iconType="kapitel" />
            )}
          </span>
          <span className="chapter-list__heading">{heading}</span>
        </button>
        <ol className="chapter-list__chapters">
          {isStringArray(chapters) &&
            chapters.map((chapter, i) => {
              return (
                <li key={`chapterlist-${i}`}>
                  <a
                    onClick={this.toggleExpanded}
                    className="chapter-list__link"
                    href={`#${i + 1}`}
                  >
                    {chapter}
                  </a>
                </li>
              );
            })}
          {!isStringArray(chapters) &&
            chapters.map((chapter, i) => {
              return (
                <li key={`chapterlist-${i}`}>
                  <a className="chapter-list__link" href={chapter.Href}>
                    {chapter.Title}
                  </a>
                </li>
              );
            })}
        </ol>
      </div>
    );
  }
}
